import styled from 'styled-components';
import { BasketMandatoryFeesStyled } from '../BasketMandatoryFeesStyled';

export const BasketMandatoryFeesDetailsAC = styled(BasketMandatoryFeesStyled)`
    .titleWrapper {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .fees {
        color: ${({ theme }) => theme.colors.grey5};
    }
`;
